import {DEFAULT_COLORS} from '@constants/colors';

const colorPalette = DEFAULT_COLORS;

const contrastColor = '#ffffff';
const backgroundColor = '#100C2A';

const axisCommon = function () {
	return {
		axisLine: {
			lineStyle: {
				color: contrastColor,
			},
		},

		/**
		 * ECharts 5 did not force an axis-label color.
		 * `null` keeps inheritance from the global text style.
		 */
		axisLabel: {
			color: null,
		},

		splitLine: {
			lineStyle: {
				color: '#484753',
			},
		},

		splitArea: {
			areaStyle: {
				color: ['rgba(255,255,255,0.02)', 'rgba(255,255,255,0.05)'],
			},
		},

		minorSplitLine: {
			lineStyle: {
				color: '#20203B',
			},
		},
	};
};

// TODO define this theme with the design once it's needed
const defaultDarkTheme = {
	darkMode: true,

	color: colorPalette,

	/**
	 * ECharts 5 bar spacing.
	 * ECharts 6 uses 10% by default.
	 */
	bar: {
		defaultBarGap: '20%',
	},

	axisPointer: {
		lineStyle: {
			color: '#817f91',
		},

		crossStyle: {
			color: '#817f91',
		},

		label: {
			backgroundColor: 'auto',

			// TODO Contrast of label backgroundColor
			color: '#fff',
		},

		shadowStyle: {
			color: 'rgba(210,219,238,0.2)',
		},
	},

	legend: {
		/**
		 * ECharts 5 positioned legends at the top by default.
		 */
		top: 0,
		bottom: null,
		itemGap: 10,

		textStyle: {
			fontWeight: 600,
			color: contrastColor,
		},
	},

	textStyle: {
		color: contrastColor,
		fontFamily: 'Inter, Arial, sans-serif',
	},

	title: {
		textStyle: {
			color: '#EEF1FA',
		},

		subtextStyle: {
			color: '#B9B8CE',
		},
	},

	toolbox: {
		iconStyle: {
			borderColor: contrastColor,
		},
	},

	// TODO define and use purple scale
	dataZoom: {
		/**
		 * ECharts 5 defaults.
		 */
		borderRadius: 3,
		defaultLocationEdgeGap: 7,

		fillerColor: 'rgba(162, 56, 255, 0.25)',
		borderColor: '#EAD3FF',

		dataBackground: {
			lineStyle: {
				color: '#DAB0FF',
			},

			areaStyle: {
				color: '#DAB0FF',
				opacity: 0.2,
			},
		},

		selectedDataBackground: {
			lineStyle: {
				color: '#A238FF',
				width: 1,
			},

			areaStyle: {
				color: '#A238FF',
				opacity: 0.2,
			},
		},

		handleStyle: {
			color: '#fff',
			borderColor: '#EAD3FF',
		},

		moveHandleStyle: {
			color: '#F3E7FF',
			borderColor: '#EAD3FF',
			opacity: 0.7,
		},

		emphasis: {
			handleStyle: {
				color: '#F3E7FF',
				borderColor: '#C37EFF',
			},

			moveHandleStyle: {
				color: '#C37EFF',
				borderColor: '#C37EFF',
				opacity: 0.7,
			},
		},

		textStyle: {
			color: contrastColor,
		},

		brushStyle: {
			color: 'rgba(162, 56, 255, 0.5)',
			opacity: 1,
		},
	},

	visualMap: {
		backgroundColor: 'rgba(0,0,0,0)',
		borderColor: '#ccc',
		contentColor: '#5793f3',
		inactiveColor: '#aaa',
		padding: 5,

		indicatorStyle: {
			shadowColor: 'rgba(0,0,0,0.2)',
		},

		textStyle: {
			color: contrastColor,
		},
	},

	/**
	 * Preserve ECharts 5 map defaults for values
	 * not explicitly configured by MapChart.
	 */
	map: {
		defaultItemStyleColor: '#eee',

		label: {
			color: '#000',
		},

		itemStyle: {
			borderColor: '#444',
			areaColor: '#eee',
		},

		emphasis: {
			label: {
				color: 'rgb(100,0,0)',
			},

			itemStyle: {
				areaColor: 'rgba(255,215,0,0.8)',
			},
		},

		select: {
			label: {
				color: 'rgb(100,0,0)',
			},

			itemStyle: {
				color: 'rgba(255,215,0,0.8)',
			},
		},
	},

	tooltip: {
		axisPointer: {
			crossStyle: {
				color: '#999',
			},
		},

		textStyle: {
			color: '#666',
		},

		backgroundColor: '#fff',
		borderWidth: 1,
		defaultBorderColor: '#fff',
	},

	timeline: {
		lineStyle: {
			color: contrastColor,
		},

		label: {
			color: contrastColor,
		},

		controlStyle: {
			color: contrastColor,
			borderColor: contrastColor,
		},
	},

	calendar: {
		itemStyle: {
			color: backgroundColor,
		},

		dayLabel: {
			color: contrastColor,
		},

		monthLabel: {
			color: contrastColor,
		},

		yearLabel: {
			color: contrastColor,
		},
	},

	timeAxis: axisCommon(),
	logAxis: axisCommon(),
	valueAxis: axisCommon(),
	categoryAxis: axisCommon(),

	line: {
		symbol: 'circle',

		/**
		 * ECharts 5 default was 4.
		 * ECharts 6 default is 6.
		 */
		symbolSize: 4,
	},

	graph: {
		color: colorPalette,
	},

	gauge: {
		title: {
			color: contrastColor,
		},
	},

	candlestick: {
		itemStyle: {
			color: '#FD1050',
			color0: '#0CF49B',
			borderColor: '#FD1050',
			borderColor0: '#0CF49B',
		},
	},
};

export default defaultDarkTheme;
